<template>
    <app-layout>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 dark:text-gray-200 leading-tight">
                Add user
            </h2>
        </template>

        <user-form :roles="roles"
                   :super-admin-role="superAdminRole"
                   :client-manager-role="clientManagerRole"
                   :clients="clients"
                   :page-types="pageTypes"
                   ></user-form>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout';
import UserForm from './Partials/UserForm';

export default {
    components: {
        AppLayout,
        UserForm,
    },
    props: {
        roles: {
            type: Array,
            required: true,
        },
        superAdminRole: {
            type: Object,
            requireD: true,
        },
        clientManagerRole: {
            type: Object,
            requireD: true,
        },
        clients: {
            type: Object,
            required: true,
        },
        pageTypes: {
            type: Object,
            required: true,
        },
    },
}
</script>
